<!-- Order Form Card -->
<div class="card mx-auto chatbot" style="max-width: 420px; height: auto; padding: 0.5rem; min-height: 100vh;" *ngIf="card">
  <div *ngIf="showSuccess" class="text-center mt-5 mb-5 p-4">
    <img [src]="pharmaLogo || 'assets/images/docquitycarelogo.svg'" alt="Docquity Care" style="width: 12rem; margin-bottom: 14rem;" />
    <div>
      <img src="assets/images/thumbs-up.svg" alt="Success" style="width: 80px; margin-bottom: 24px;" />
    </div>
    <h3 style="font-weight: bold; margin-bottom: 12px;">{{ 'CONGRATULATIONS' | translate }}</h3>
    <div style="color: #888; font-size: 16px;">
      {{ 'REGISTRATION_SUCCESS_MESSAGE' | translate }}
    </div>
  </div>
  <div class="text-center mt-5 mb-5 p-4" *ngIf="!showSuccess && !isLoadingData && !programLoader && !programSelectionResultVisible" [ngClass]="orderSuccess ? '' : 'd-none'">
    <img [src]="pharmaLogo || 'assets/images/docquitycarelogo.svg'" alt="Docquity Care" style="width: 12rem; margin-bottom: 5rem;" />
    <div *ngIf="orderSuccessData?.data?.orderCondition">
      <img src="assets/images/thumbs-up.svg" alt="Success" style="width: 80px; margin-bottom: 24px;" />
    </div>
    <div *ngIf="!orderSuccessData?.data?.orderCondition">
      <img src="assets/images/chatform-alert.svg" alt="Failure" style="width: 80px; margin-bottom: 24px;" />
    </div>
    <div *ngIf="orderSuccessData?.data?.orderCondition; else FailedOrderCondition">
      <h3 class="mb-2 mt-2 fnt-size24px color-1D1919 font-lexend medium-font-weight">
        {{ 'YOUR_ORDER_HAS_BEEN_PLACED' | translate }}
      </h3>
      <div  class="mb-2 fnt-size14px color-737171 font-manrope medium-font-weight">
        {{ 'YOUR_ORDER_HAS_BEEN_PLACED_MESSAGE' | translate }}
      </div>
    </div>
    <ng-template #FailedOrderCondition>
      <h3 class="mb-2 mt-2 fnt-size24px color-1D1919 font-lexend medium-font-weight" *ngIf="orderSuccessData?.data?.failureReason == 'PREVIOUS_ORDER_NOT_COMPLETED'">
        {{ 'PREVIOUS_ORDER_NOT_COMPLETED' | translate }}
      </h3>
      <h3 class="mb-2 mt-2 fnt-size24px color-1D1919 font-lexend medium-font-weight" *ngIf="orderSuccessData?.data?.failureReason == 'LIMIT_EXCEEDED'">
        {{ 'LIMIT_EXCEEDED' | translate }}
      </h3>
      <div class="fnt-size14px color-737171 font-manrope medium-font-weight" *ngIf="orderSuccessData?.data?.failureReason == 'PREVIOUS_ORDER_NOT_COMPLETED'">
        <div class="mb-2">{{ 'PREVIOUS_ORDER_NOT_COMPLETED_MESSAGE_1' | translate }}</div>
        <div class="mb-2">{{ 'PREVIOUS_ORDER_NOT_COMPLETED_MESSAGE_2' | translate }}</div>
      </div>
      <div class="fnt-size14px color-737171 font-manrope medium-font-weight" *ngIf="orderSuccessData?.data?.failureReason == 'LIMIT_EXCEEDED'">
        <div class="mb-2">{{ 'LIMIT_EXCEEDED_MESSAGE' | translate }}</div>
      </div>
    </ng-template>
    <div class="my-4" *ngIf="orderSuccessData?.data?.orderCondition">
      <span class="alert alert-info text-center rounded-8 fnt_Bold fnt-size14px">{{ 'ORDER_DETAIL_PRESCRIPTION_ID' | translate }} - {{ orderSuccessData?.data.prescriptionId }}</span>
    </div>
    <div class="order-success-footer edit-button" (click)="onViewOrderDetails()" *ngIf="orderSuccessData?.data?.orderCondition">
      <span class="fnt_Weight_600 fnt-size16px">{{ 'VIEW_ORDER_DETAILS' | translate }} <img src="assets/images/right-arrow.svg" alt="right-arrow"></span>
    </div>
  </div>
  <div class="text-center mt-5 mb-5 p-4" *ngIf="programSelectionResultVisible ">
    <img [src]="pharmaLogo || 'assets/images/docquitycarelogo.svg'" alt="Docquity Care" style="width: 12rem; margin-bottom: 3rem;" />
    <div>
      <img src="assets/images/chatform-alert.svg" alt="Success" style="width: 80px; margin-bottom: 24px;" />
    </div>
    <h3 class="mb-2 mt-2 fnt-size24px color-1D1919 font-lexend medium-font-weight">
      {{ 'PROGRAM_NOT_AVAILABLE' | translate }}
    </h3>
    <div class="mb-3 fnt-size14px color-737171 font-manrope medium-font-weight">
      {{ programSelectionMessageKey | translate }}
    </div>
  </div>
  <div *ngIf="!showSuccess && !isLoadingData && !programLoader && !programSelectionResultVisible" [ngClass]="orderSuccess ? 'd-none' : ''">
    <div style="width: 24px; margin-left: 5%; margin-bottom: 1%;" [ngClass]="orderPreview ? 'd-none' : ''">
      <img src="assets/images/left-back.svg" alt="Back" style="width: 32px; height: 32px; cursor: pointer;" (click)="goToPreviousCard()" />
    </div>
    <div class="alert alert-info text-center rounded-4" style="margin-left: 5%; margin-right: 5%;" *ngIf="(card?.pageName === 'order' || card?.pageName === 'orderDetails')" [ngClass]="orderPreview ? 'mt-4' : ''">
        {{ pharmaTagline || ('CHATBOT_DEFAULT_TAGLINE' | translate) }}
    </div>
    <div class="card-body mb-3" *ngIf="card?.pageName === 'orderDetails'" [ngClass]="!orderPreview ? 'd-none' : ''">
      <div>
        <p class="fnt_Medium fnt-size16px">{{ 'ORDER_DETAILS' | translate }}</p>
        <div class="border rounded-8 p-3 mt-3">
          <div class="d-flex align-items-center justify-content-between m-1">
            <div class="d-flex flex-column align-items-start pr-2">
              <p class="fnt_Weight_600 fnt-size16px">{{ currentCardForm.get(['drugs', 0])?.value?.genericName }} ({{ currentCardForm.get(['drugs', 0])?.value?.name }}) {{ currentCardForm.get(['drugs', 0])?.value?.strength.value }} {{ currentCardForm.get(['drugs', 0])?.value?.strength.unit.name }}</p>
              <p class="fnt_Medium fnt-size14px">{{ currentCardForm.get(['drugs', 0])?.value?.quantity }} boxes</p>
            </div>
            <div *ngIf="!submittedOrder" class="fnt_Weight_600 fnt-size16px cursor-pointer edit-button pl-2" (click)="onEditOrder()">{{ 'EDIT' | translate }}</div>
          </div>
        </div>
      </div>
      <div class="order-detail-footer">
        <div class="d-flex flex-row align-items-center justify-content-between">
          <p class="fnt_Medium fnt-size16px">{{ 'PHARMACY_CODE' | translate }}</p>
          <p *ngIf="!submittedOrder" class="fnt_Medium fnt-size16px cursor-pointer edit-button text-info" (click)="onEditOrder()">{{ 'CHANGE' | translate }}</p>
        </div>
        <div class="border rounded-8 p-3 mt-3">
          <p class="d-flex flex-row align-items-center">
            <img src="assets/images/clinicLogo.svg" alt="{{ 'PHARMACY_CODE' | translate }}" style="width: 32px; height: 32px;">
            <span class="fnt_Medium fnt-size16px ml-2">{{ currentCardForm.get(['treatmentClinic'])?.value.name }}</span>
          </p>
        </div>
        <button *ngIf="!submittedOrder" type="submit" class="btn btn-block w-100 mt-4" [ngStyle]="{
          'background': '#232323',
          'color': '#fff',
          'border': 'none'
        }" (click)="onCardSubmit(card)"
        [disabled]="currentCardForm?.invalid">
        {{ 'SUBMIT_ORDER' | translate }}
      </button>
      </div>
    </div>
    <div class="card-body mb-3" [ngClass]="orderPreview ? 'd-none' : ''">
      <h4 class="card-title mb-3" style="font-size: 1.1rem; font-weight: bold;">{{ card.title | translate }}</h4>
      <p class="text-muted mb-4" *ngIf="card.description">{{ card.description | translate }}</p>
      <!-- Consent Card -->
      <form *ngIf="card.type === 'consent'" [formGroup]="consentForm" (ngSubmit)="onConsentSubmit()">
        <div class="terms-container mb-4">
          <div *ngFor="let term of terms; let i = index">
            <div class="mt-2" *ngIf="i <= 2">
              <div class="d-flex flex-row align-items-start mt-2 custom-control custom-checkbox">
                <input class="mr-2 custom-control-input" type="checkbox" id="checkbox_{{i}}" [checked]="true" [disabled]="true">
                <label class="custom-control-label" for="checkbox_{{i}}">
                  <span class="fnt-size12px text-rolling-stone-grey text-break" [innerHTML]=convertToUrlWithoutProtocol(term)></span>
                  <span class="fnt-size12px text-rolling-stone-grey" *ngIf="!showAllTerms && i === 2 && terms.length > 3">...</span>
                  <p class="text-success fnt-size12px cursor-pointer" *ngIf="!showAllTerms && i === 2 && terms.length > 3" (click)="showAllTerms = true">{{'READ_MORE' | translate}}</p>
                </label>
              </div>
            </div>
            <div *ngIf="i > 2 && showAllTerms">
              <div class="d-flex flex-row align-items-start mt-2 custom-control custom-checkbox">
                <input class="mr-2 custom-control-input" type="checkbox" id="checkbox_{{i}}" [checked]="true" [disabled]="true">
                <label class="custom-control-label" for="checkbox_{{i}}">
                  <span class="fnt-size12px text-rolling-stone-grey text-break" [innerHTML]=convertToUrlWithoutProtocol(term)></span>
                  <p class="text-success fnt-size12px cursor-pointer" *ngIf="showAllTerms && i + 1 === terms.length" (click)="showAllTerms = false">{{'READ_LESS' | translate}}</p>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="form-check mb-4 d-none">
          <input type="checkbox" class="form-check-input" id="termsAccepted" formControlName="termsAccepted">
          <label class="form-check-label" for="termsAccepted">{{ 'ACCEPT_TERMS' | translate }}</label>
        </div>
        <button type="submit" class="btn btn-block w-100"
          [ngStyle]="{
            'background': consentForm.valid ? '#232323' : '#D3D3D3',
            'color': '#fff',
            'border': 'none'
          }"
          [disabled]="consentForm.invalid">
          {{ card.submitText | translate }}
        </button>
      </form>
      <!-- Regular Form Card -->
      <form *ngIf="card.fields" [formGroup]="currentCardForm" (ngSubmit)="onCardSubmit(card)">
        <ng-container *ngIf="card.fields">
          <div class="form-group mb-3" *ngFor="let field of card.fields">
            <label *ngIf="field.label" for="{{field.key}}">{{ getFieldLabelKey(field) | translate }} <span class="text-danger" *ngIf="field.isRequired">*</span></label>

            <!-- Caregiver Mobile Number: Custom Combined Field -->
            <ng-container *ngIf="field.key === 'caregiverMobile'; else notCaregiverMobile">
              <div class="d-flex align-items-center" style="gap: 8px;">
                <div style="position: relative; min-width: 110px; max-width: 110px;">
                  <img [src]="selectedCountryFlag" width="22" height="16"
                       style="position: absolute; left: 10px; top: 50%; transform: translateY(-50%); z-index: 2; pointer-events: none;" />
                  <select class="form-control"
                          style="padding-left: 38px; height: 40px; border-radius: 6px; -webkit-appearance: none; appearance: none; background-image: url('assets/images/dropdown-icon.svg'); background-repeat: no-repeat; background-position: right 8px center; padding-right: 24px;"
                          [formControlName]="'caregiverCountryCode'">
                    <option *ngFor="let country of countries" [value]="country.dialCode">
                      {{ country.dialCode }}
                    </option>
                  </select>
                </div>
                <input type="tel"
                       class="form-control"
                       [formControlName]="'caregiverMobile'"
                       [placeholder]="getFieldPlaceholderKey(field) | translate"
                       maxlength="15"
                       minlength="8"
                       (keyup)="userInput(card.pageName,field.key, $event)"
                       (input)="preventSpaces(card.pageName,field.key, $event)"
                       (keypress)="onlyNumbers($event)"
                       style="height: 40px; border-radius: 6px; flex: 1 1 auto;" />
              </div>
              <div *ngIf="isFieldInvalid(card.pageName, field.key)" class="text-danger fnt-size12px">
                {{ field.required | translate }}
              </div>
              <div *ngIf="isFieldInvalid(card.pageName, field.key) && field.patternError" class="text-danger fnt-size12px">
                {{ field.patternError | translate }}
              </div>
            </ng-container>

            <ng-template #notCaregiverMobile>
              <!-- Autocomplete for search type -->
              <ng-container *ngIf="field.type === 'search'; else defaultField">
                <div *ngIf="field?.key !== 'program'">
                  <p-dropdown
                  [styleClass]="'w-100 custom-dropdown'"
                  [panelStyle]="{ 'min-width': '350px' }"
                  [placeholder]="getFieldPlaceholderKey(field) | translate"
                  [options]="getFieldOptionList(field?.key)"
                  optionLabel="name"
                  [disabled]="getFieldOptionList(field?.key).length === 0"
                  (onChange)="onSelectItem($event?.value, field?.key)"
                  ([ngModel])="(field?.key === 'quantity' ? currentCardForm.get(['drugs', 0, field?.key])?.value :currentCardForm.get(field?.key)?.value)">
                  <ng-template let-item pTemplate="item">
                    <div class="dropdown-program-item">
                      <div class="program-title">
                        <span *ngIf="item === null || item === undefined">No option</span>
                        <span class="white-space-normal" *ngIf="field?.key === 'drugs' else noDrug">{{ item.genericName }} ({{ item.name }}) {{ item.strength.value }} {{ item.strength.unit.name }}</span>
                        <ng-template #noDrug>
                          <span class="white-space-normal">{{ item.name }}</span>
                        </ng-template>
                      </div>
                    </div>
                  </ng-template>
                  <ng-template pTemplate="selectedItem" let-selectedItem>
                    <div class="selected-program-template">
                      <div class="program-title">
                        <span class="white-space-normal" *ngIf="field?.key === 'drugs' else noDrugSelected">{{ selectedItem.genericName }} ({{ selectedItem.name }}) {{ selectedItem.strength.value }} {{ selectedItem.strength.unit.name }}</span>
                        <ng-template #noDrugSelected>
                          <span class="white-space-normal">{{ selectedItem.name }}</span>
                        </ng-template>
                      </div>
                    </div>
                  </ng-template>
                  </p-dropdown>
                </div>
                <div *ngIf="field?.key === 'program'">
                <p-dropdown
                  [styleClass]="'w-100 custom-dropdown'"
                  [panelStyle]="{ 'min-width': '350px' }"
                  [placeholder]="'SELECT_PROGRAM_OR_DRUG_NAME' | translate"
                  formControlName="program"
                  [options]="programList"
                  optionLabel="Program.Name"
                  (onChange)="onSelectProgram($event.value)">
                  <ng-template let-program pTemplate="item">
                    <div class="dropdown-program-item">
                      <div class="program-title">{{ program.Program.Name }}</div>
                      <div class="program-drugs">
                        <ng-container *ngFor="let drug of program.Program.Drugs; let isLast=last">
                          <p>
                            <span>{{ drug.GenericName }} ({{ drug.BrandName }})</span>
                          </p>
                        </ng-container>
                      </div>
                    </div>
                  </ng-template>
                  <ng-template pTemplate="selectedItem" let-selectedProgram>
                    <div class="selected-program-template">
                      <div class="program-title">{{ selectedProgram.Program.Name }}</div>
                      <div class="program-drugs">
                        <ng-container *ngFor="let drug of selectedProgram.Program.Drugs; let isLast=last">
                          <p>
                            <span>{{ drug.GenericName }} ({{ drug.BrandName }})</span>
                          </p>
                        </ng-container>
                      </div>
                    </div>
                  </ng-template>
                </p-dropdown>
              </div>
              </ng-container>
              <ng-template #defaultField>
                <div *ngIf="field.key === 'treatmentHospital'" formGroupName="treatmentHospital">
                  <input type="text" formControlName="name" class="form-control input-field" [placeholder]="field.placeholder | translate" [maxlength]="100" (input)="userInput(card.pageName, field.key + '.name', $event)"/>
                </div>
                <input *ngIf="(field.type === 'text' || field.type === 'tel') && field.key !== 'treatmentHospital'" 
                       [type]="field.type" 
                       class="form-control input-field" 
                       [formControlName]="field.key"
                       [placeholder]="getFieldPlaceholderKey(field) | translate"
                       [maxlength]="field.maxLength"
                       (keypress)="field.key === 'firstName' || field.key === 'middleName' || field.key === 'lastName' || field.key === 'initials' ? noSpecialChars($event) : null"
                       (input)="(field.key === 'firstName' || field.key === 'middleName' || field.key === 'lastName' || field.key === 'address' || field.key === 'caregiverName' || field.key === 'idCardNumber' || field.key === 'initials' || field.key === 'prescriptionNo') ? userInput(card.pageName,field.key, $event) : null" />
                <div *ngIf="field.type === 'date'" class="calendar-field w-100">
                  <p-calendar [showIcon]="true" 
                            [monthNavigator]="true" 
                            [yearNavigator]="true" 
                            yearRange="1922:2030" 
                            [inline]="false" 
                            panelStyleClass="bg-white border"
                            [maxDate]="(field.key === 'dob' || field.key === 'dateOfPrescription') ? today : null"
                            [inputStyleClass]="'form-control fnt-size12px fnt_Medium'"
                            [formControlName]="field.key"
                            [placeholder]="getFieldPlaceholderKey(field) | translate"
                            dateFormat="dd M yy">
                  </p-calendar>
                </div>
                <textarea *ngIf="field.type === 'textarea'"
                          class="form-control"
                          [formControlName]="field.key"
                          [placeholder]="getFieldPlaceholderKey(field) | translate"
                          [maxlength]="field.maxLength"
                          (keyup)="(field.key === 'address') ? userInput(card.pageName,field.key, $event) : null"
                          rows="3"></textarea>
                <select *ngIf="field.type === 'select' || field.type === 'dropdown'" 
                        class="form-control select" 
                        [formControlName]="field.key">
                  <option value="" disabled selected hidden>{{ getFieldPlaceholderKey(field) | translate }}</option>
                  <option *ngFor="let option of field.options" [value]="option.value">{{option.label | translate}}</option>
                </select>
                <div *ngIf="field.type === 'file'" class="file-upload-container">
                  <label
                    class="d-block w-100"
                    style="border: 2px dashed #ccc; border-radius: 8px; padding: 20px; text-align: center; cursor: pointer; background: #fafbfc;"
                    for="fileInput"
                    >
                    <div style="display: flex; flex-direction: column; align-items: center;">
                      <img src="assets/images/upload-photo-icon.svg" width="40" height="40" alt="Upload" style="margin-bottom: 8px;" />
                      <span style="color: #0070f3; font-weight: 500;">{{ 'UPLOAD_ID_PHOTO' | translate }}</span>
                      <span style="color: #888; font-size: 12px;">{{ 'UPLOAD_ID_HINT' | translate }}</span>
                      <span *ngIf="idCardFileName" style="color: #333; font-size: 13px; margin-top: 8px;">{{ idCardFileName }}</span>
                    </div>
                    <input
                      type="file"
                      id="fileInput"
                      class="d-none"
                      #fileInput
                      (change)="onIdCardFileChange($event)"
                      accept="image/jpeg,image/png"
                      (click)="$event.stopPropagation()"
                    />
                  </label>
                  <div *ngIf="idCardFileError" class="text-danger fnt-size12px mt-1">
                    {{ idCardFileError }}
                  </div>
                  <div *ngIf="idCardImageSrc" class="mt-2">
                    <img [src]="idCardImageSrc" class="img-thumbnail" style="max-width: 200px;" />
                  </div>
                </div>
                <div *ngIf="isFieldInvalid(card.pageName, field.key)" class="text-danger fnt-size12px">
                  {{ field.required | translate }}
                </div>
                <div *ngIf="isFieldInvalid(card.pageName, field.key) && field.patternError" class="text-danger fnt-size12px">
                  {{ field.patternError | translate }}
                </div>
              </ng-template>
            </ng-template>
          </div>
        </ng-container>
        <button type="submit" class="btn btn-block w-100"
          [ngStyle]="{
            'background': currentCardForm?.valid ? '#232323' : '#D3D3D3',
            'color': '#fff',
            'border': 'none',
            'margin-top': card.pageName === 'order' ? '20rem' : '0'
          }"
          [disabled]="currentCardForm?.invalid">
          {{ card.submitText | translate }}
        </button>
      </form>
    </div>
  </div>
</div>
